import {createContext} from 'react'

function noop () {}

export const CardContext = createContext ( {
    cardForm: null,
    createForm: noop,
    homeConfirm: null,
    setHomeConfirm: noop,
    pendingTarget: null,
    setPendingTarget: noop
})